import { render, staticRenderFns } from "./ai-sparkle.vue?vue&type=template&id=6eb2f021&"
import script from "./ai-sparkle.vue?vue&type=script&lang=js&"
export * from "./ai-sparkle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6eb2f021')) {
      api.createRecord('6eb2f021', component.options)
    } else {
      api.reload('6eb2f021', component.options)
    }
    module.hot.accept("./ai-sparkle.vue?vue&type=template&id=6eb2f021&", function () {
      api.rerender('6eb2f021', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/ai-sparkle.vue"
export default component.exports